import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { UserService } from 'src/app/routes/toolbox/services/user/user.service';

/**
 * Guard that blocks route activation until UserService.me() is non-null.
 * Relies on AppComponent calling subscribeToMe() on startup.
 */
export const userLoadedGuard: CanActivateFn = () => {
  const userService = inject(UserService);

  return toObservable(userService.me).pipe(
    filter((me) => me !== null),
    take(1),
    map((me) => !!me)
  );
};
